import { Phone, Mail, MapPin, ArrowUp } from "lucide-react";
import { scrollToId } from "@/App";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="relative bg-[#0E1E12] border-t border-[#A6CE39]/10 overflow-hidden">
            <span
                aria-hidden
                className="absolute -bottom-8 left-1/2 -translate-x-1/2 font-display font-black text-[18vw] leading-none text-outline select-none pointer-events-none"
            >
                HLV
            </span>
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <img src="/assets/logo.jpg" alt="HealthLogic Vending logo" className="h-11 w-11 object-cover rounded-full ring-1 ring-[#A6CE39]/25" />
                            <p className="font-display text-xl font-extrabold text-[#F9F8F3] tracking-tight">
                                HealthLogic<span className="text-[#A6CE39]">.</span>
                                <span className="text-[#F9F8F3]/50 font-medium text-sm ml-2">Vending</span>
                            </p>
                        </div>
                        <p className="text-sm text-[#F9F8F3]/50 max-w-xs leading-relaxed">
                            Smart, healthy vending — installed and stocked free in Northern Virginia workplaces.
                        </p>
                    </div>

                    <div className="flex flex-col gap-3 text-sm" data-testid="footer-contact">
                        <a href="tel:+15712811784" data-testid="footer-phone-link" className="flex items-center gap-2.5 text-[#F9F8F3]/70 hover:text-[#A6CE39] transition-colors duration-300">
                            <Phone className="h-4 w-4 text-[#A6CE39]" /> 571-281-1784
                        </a>
                        <a href="mailto:aleassear@crisislogic.com" data-testid="footer-email-link" className="flex items-center gap-2.5 text-[#F9F8F3]/70 hover:text-[#A6CE39] transition-colors duration-300">
                            <Mail className="h-4 w-4 text-[#A6CE39]" /> aleassear@crisislogic.com
                        </a>
                        <p className="flex items-center gap-2.5 text-[#F9F8F3]/70" data-testid="footer-area">
                            <MapPin className="h-4 w-4 text-[#A6CE39]" /> Northern Virginia
                        </p>
                    </div>

                    <div className="flex flex-col gap-3 text-sm">
                        <p className="font-mono-brand text-[11px] tracking-[0.25em] uppercase text-[#A6CE39] mb-1">Explore</p>
                        {[
                            ["About", "#about"],
                            ["Snacks", "#snacks"],
                            ["How it works", "#how-it-works"],
                            ["Partners", "#partners"],
                            ["Free placement", "#contact"],
                        ].map(([label, href]) => (
                            <button
                                key={href}
                                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                                onClick={() => scrollToId(href)}
                                className="text-left text-[#F9F8F3]/70 hover:text-[#A6CE39] transition-colors duration-300"
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-[#A6CE39]/10 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-[#F9F8F3]/40" data-testid="footer-copyright">
                        © {new Date().getFullYear()} HealthLogic Vending · hlvend.com
                    </p>
                    <button
                        data-testid="footer-back-to-top-btn"
                        onClick={() => window.__lenis?.scrollTo(0)}
                        className="flex items-center gap-2 text-xs font-semibold text-[#F9F8F3]/60 hover:text-[#A6CE39] transition-colors duration-300"
                    >
                        Back to top <ArrowUp className="h-3.5 w-3.5" />
                    </button>
                </div>
            </div>
        </footer>
    );
}
